import { useConfiguration } from "../dataAccess/api/configuration";

const translationKeys = [
  "reviews_thanks",
  "reviews_pending_review",
  "reviews_accept",
  "information_generic_error",
  "information_reset_password",
  "information_refresh",
  "seo_sign_in_meta_description",
  "seo_plp_meta_description",
  "seo_sign_up_meta_description",
  "information_page_not_found",
  "information_listing_not_available_title",
  "information_listing_not_available_description",
  "information_back_to_marketplace_button",
  "information_email_required",
  "information_acknowledgment_required",
  "information_phone_number_required",
  "information_phone_number_invalid",
  "information_organization_name_required",
  "information_user_full_name_required",
  "information_password_required",
  "information_terms_and_conditons",
  "information_email_valid",
  "information_password_min_length",
  "information_password_password.password_strength",
  "information_upload_file_restrictions",
  "information_string_not_allowed",
  "information_form_field_required",
  "information_password_max_length",
  "information_password_missing_lowercase",
  "information_password_missing_uppercase",
  "information_password_missing_digit",
  "information_password_missing_special_char",
  "information_password_must_match",
  "information_review_quote_required",
  "information_captcha_required",
  "information_cookies",
  "information_allow_cookies",
  "information_help_article",
  "information_contact_support",
  "information_logout",
  "information_empty_search_results",
  "information_change_search_terms",
  "information_clear_filters",
  "information_jwt_auth_failed",
  "information_jwt_invitation_wrong_email",
  "information_jwt_try_again_contact_us",
  "information_try_again",
  "information_contact_us",
  "information_account_under_review",
  "information_access_requested",
  "information_go_back_to_company_website",
  "information_sign_out",
  "information_verification_no_email",
  "information_email_sent",
  "information_password_token_invalid",
  "information_email_taken",
  "information_uid_taken",
  "information_invalid_credentials",
  "information_pending_organization_approval",
  "information_pending_guest_approval",
  "information_pending_review",
  "information_session_timed_out",
  "accessibility_logo_alt_text",
  "accessibility_registration_form",
  "accessibility_filters",
  "information_previous",
  "accessibility_next_alt_text",
  "accessibility_close_alt_text",
  "accessibility_previous_alt_text",
  "editions_pricing",
  "editions_revenue_type_free",
  "editions_most_popular",
  "editions_frequency_hourly",
  "editions_frequency_daily",
  "editions_frequency_weekly",
  "editions_frequency_monthly",
  "editions_frequency_quarterly",
  "editions_frequency_semi_annually",
  "editions_frequency_annually",
  "editions_frequency_biennially",
  "editions_frequency_triennially",
  "editions_contract_fee",
  "editions_contract_minimum_length",
  "editions_setup_fee",
  "editions_included_items",
  "editions_included_items_unlimited",
  "discounts_up_to_savings",
  "discounts_save",
  "discounts_new_customers",
  "discounts_existing_customers",
  "discounts_redemption_instructions",
  "discounts_special_restrictions",
  "discounts_upgraded",
  "discounts_better_deal",
] as const;

export type TranslationKey = (typeof translationKeys)[number];

const translationKeySet = new Set<string>(translationKeys);

export type BaseLanguage = { key: TranslationKey; value: string }[];

function t(key: TranslationKey, data?: BaseLanguage) {
  const translation = (data || []).find(({ key: dataKey }) => key === dataKey);

  if (!translation) {
    console.error(`No translation found for key: ${key}`);
  }

  return translation?.value || "";
}

export function useTranslation() {
  const { configuration } = useConfiguration();
  return {
    t: (key: TranslationKey) => t(key, configuration?.staticPhrases),
  };
}

export function isTranslationKey(key: string): key is TranslationKey {
  return translationKeySet.has(key);
}
